import { cloneElement, isValidElement, PropsWithChildren } from 'react'

import theme from 'theme_'
import { StyledCardIcon, StyledIconWrapper } from '../styles'

interface RenderIconProps {
  color?: string
  hideOnDesktop?: boolean
}

export const RenderIcon = ({
  children,
  color,
  hideOnDesktop,
}: PropsWithChildren<RenderIconProps>) => {
  if (typeof children === 'string')
    return (
      <StyledIconWrapper hideOnDesktop={hideOnDesktop}>
        <StyledCardIcon
          path={children}
          color={color || theme.colors.horizonOrange}
        />
      </StyledIconWrapper>
    )
  if (!isValidElement(children)) return null

  return (
    <StyledIconWrapper hideOnDesktop={hideOnDesktop}>
      {cloneElement(children, {
        color: color || theme.colors.horizonOrange,
      })}
    </StyledIconWrapper>
  )
}
